import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { knmSetLoadingFlags } from 'KnmPackage/MainModule/actions/knmActions';
import { KnmLoadingFlagsEnum } from 'KnmPackage/MainModule/enums/KnmLoadingFlagsEnum';

export function useKnmSetFnsLookupLoadingFlags() {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const setFnsLookupByOgrnLoadingFlag = useCallback(
    (value: boolean) => dispatch(knmSetLoadingFlags(KnmLoadingFlagsEnum.FNS_LOOKUP_BY_OGRN, value)),
    [dispatch],
  );

  const setFnsLookupByInnLoadingFlag = useCallback(
    (value: boolean) => dispatch(knmSetLoadingFlags(KnmLoadingFlagsEnum.FNS_LOOKUP_BY_INN, value)),
    [dispatch],
  );

  return {
    setFnsLookupByOgrnLoadingFlag,
    setFnsLookupByInnLoadingFlag,
  };
}
